import React from 'react';
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export function RadioButton(props: Props) {
  const {t} = useTranslation();

  return (
    <Container style={props?.style ?? {}}
               disabled={!!props.disabled}
               onClick={!!props.disabled ? () => {} : () => props.onChange()}>
      <input type="radio"
             className={'radioButton__input'}
             disabled={!!props.disabled}
             name={props.value} checked={props.selected}/>
      {props.text && <label htmlFor={props.value} className={'radioButton__label' + (props.value ? ` radioButton__label--checked` : '')}>{t(props.text)}</label>}
    </Container>
  );
}

interface Props {
  text?: string;
  disabled?: boolean;
  value: string;
  onChange: () => any;
  selected: boolean;
  flip?: boolean;
  style?: any;
}

const Container = styled.div<any>`
  display: inline-flex;
  cursor: ${props => !!props.disabled ? 'cursor' : 'pointer'};
  * {
    user-select: none;
  }
  input {
    cursor: ${props => !!props.disabled ? 'cursor' : 'pointer'};
  }
  label {
    cursor: ${props => !!props.disabled ? 'cursor' : 'pointer'};
  }
`
